module.exports = __webpack_public_path__ + "static/img/manageAccountIcon.bf59e3f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/manageAccountIcon.svg
// module id = yRc5
// module chunks = 74